<template>
  <v-app>
    <router-view />
    <v-snackbars top color="error" :objects.sync="$store.state.snack"></v-snackbars>
    <v-dialog ref="viewImgBox" :width="boxWidth" v-model="dialog">
      <v-img :src="$store.state.viewimg" @click.stop="dialog = false"></v-img>
    </v-dialog>
  </v-app>
</template>

<script>
  import VSnackbars from "v-snackbars";
  export default {
    name: "App",
    components: {
      "v-snackbars": VSnackbars,
		},
		data: function(){
			return {
				boxWidth: 800
			}
		},
		watch: {
      dialog(val) {
				let _this = this
        if (val) {
					var imgData = _this.$store.state.viewimg
					var img = new Image();
					img.onload = function(){
						if(img.width < 800){
							_this.boxWidth = img.width < 100 ? 100 : img.width
						}else{
							_this.boxWidth = 800
						}
					};
					img.src = imgData; 
				}
      },
    },
    computed: {
      dialog: {
        get: function () {
          return !!this.$store.state.viewimg;
        },
        set: function (newval) {
          newval || this.$store.commit("setviewimg", null);
        },
      },
      snack: {
        get: function () {
          return this.$store.state.snack;
        },
        set: function (newval) {
          this.$store.commit("setsnack", newval);
        },
      },
    },
  };
</script>
<style>
.v-data-table table tbody > tr > td:nth-child(-n+2),
.v-data-table table thead > tr > th:nth-child(-n+2),
.v-data-table table tbody > tr > td:last-child,
.v-data-table table thead > tr > th:last-child {
  position: sticky !important;
  position: -webkit-sticky !important;
  z-index: 1;
  background: white;
}

.v-data-table table tbody > tr > td:nth-child(1),
.v-data-table table thead > tr > th:nth-child(1) {
  left: 0;
}

.v-data-table table tbody > tr > td:nth-child(2),
.v-data-table table thead > tr > th:nth-child(2) {
  left: 56px;
}

.v-data-table table tbody > tr > td:last-child,
.v-data-table table thead > tr > th:last-child {
  right: 0;
}
</style>